import { createSelector } from '@reduxjs/toolkit';

import {
  DataSourceType,
  UNKNOWN_DATA_SOURCE_FAMILY,
  UNKNOWN_DATA_SOURCE_TYPE,
} from 'src/constants/dataSourceTypeDescription';
import { dataSourceTypesSelector } from 'src/selectors/dataSourceTypes';
import { Connection } from 'src/store/connections/types';

export const dataSourceFamiliesByTypeSelector = (
  connection: Connection | null
) =>
  createSelector(
    dataSourceTypesSelector(connection),
    (dataSourceTypes): Record<DataSourceType, string> =>
      Object.entries(dataSourceTypes).reduce(
        (agg, [dataSourceType, { dataSourceFamily }]) => ({
          ...agg,
          [dataSourceType]: dataSourceFamily || UNKNOWN_DATA_SOURCE_FAMILY,
        }),
        {
          [UNKNOWN_DATA_SOURCE_TYPE]: UNKNOWN_DATA_SOURCE_FAMILY,
        }
      )
  );
